import styled from "styled-components";

export const Footer = styled.footer`
    text-align: center;
    margin: 0.5rem;
`;

export const PageModal = styled.div`
    position: fixed;
    z-index: 3000;
`;
